<template>
  <div id="add-user" class="m-t-10">
    <form action="#" v-on:submit.prevent="submitForm">
      <div class="row ml-2">
        <div class="col-md-12">
          <h6>Judul</h6>
          <p>{{ data[0].judul }}</p>
          <h6 class="mt-4">Deskripsi</h6>
          <p>{{ data[0].content != "" ? data[0].content : "-" }}</p>
          <h6 class="mt-4">Tanggal</h6>
          <select
            class="form-control form-custom w-50 mb-4"
            v-model="selectDate"
            id="selectTanggal"
            @change="onChangeSelect"
          >
            <option
              v-for="(tanggal, index) in data[0].date"
              :key="index"
              :value="data[0].ids[index]"
            >
              {{ tanggal }}
            </option>
          </select>
        </div>
      </div>
      <div class="form-group" :key="keyTable">
        <table class="table table-bordered" id="listStreamTable" width="100%">
          <thead>
            <tr>
              <th width="50%">Judul</th>
              <th width="15%">Media</th>
              <th>Tanggal</th>
              <th class="text-center">Link</th>
            </tr>
          </thead>
          <tbody></tbody>
        </table>
      </div>
      <div class="form-group">
        <pagination-component
          v-if="page_info != null"
          :key="pagination_key"
          class="pull-left"
          :data="page_info"
          :goto="true"
        />
      </div>
      <div class="form-group" align="right">
        <button type="button" class="btn btn-danger m-r-5" data-dismiss="modal">
          Batal
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import $ from "jquery";
import notif from "@/assets/js/notif.js";
import gp from "@/plugins/generalPlugins.js";
import pagintaion_component from "@/views/components/pagination.vue";

$.pgNotification = notif;

export default {
  name: "modal_newstrend_post",
  components: {
    "pagination-component": pagintaion_component,
  },
  props: {
    data: Array,
  },
  data() {
    return {
      q: null,
      id_trend: this.data[0].idTrend,
      dataBerita: {},
      page_info: null,
      pagination_key: 0,
      dataStream: [],
      selectDate: this.data[0].idTrend,
      keyTable: 10,
    };
  },
  methods: {
    dateindo: function (tanggal) {
      return gp.dateTimeID(tanggal);
    },
    clickCheckbox: function (idStream) {
      var index = this.dataStream.indexOf(idStream);
      if (index != -1) {
        this.dataStream.splice(index, 1);
      } else {
        this.dataStream.push(idStream);
      }
    },
    checkData: function (idStream) {
      var index = this.dataStream.indexOf(idStream);
      let status = false;
      if (index != -1) {
        status = true;
      }
      return status;
    },
    onChangeSelect: function (e) {
      if (e.target.options.selectedIndex > -1) {
        this.$parent.data_modal.subtitle =
          "news trend pada tanggal " +
          this.data[0].date[e.target.options.selectedIndex];
        this.getData();
      }
    },
    getData: function () {
      let self = this;
      let urlParent = window.location.origin;
      if (this.selectDate != "") {
        this.id_trend = this.selectDate;
      }
      let api =
        process.env.VUE_APP_API_URL + "newstrend/streams/" + this.id_trend;
      this.$http
        .get(api)
        .then(function (response) {
          if (response.status == 204) {
            self.dataBerita = {};
            self.page_info = null;
          } else {
            self.table.clear().draw();
            self.dataBerita = response.data.streams_list;
            for (let index in self.dataBerita) {
              let date = gp.dateTimeID(self.dataBerita[index].date.$date);
              let urlMediaTv =
                urlParent + "/view?id=" + self.dataBerita[index]._id.$oid;

              let url =
                self.dataBerita[index].source == "media_cetak" ||
                self.dataBerita[index].source == "media_tv"
                  ? urlMediaTv
                  : self.dataBerita[index].url;
              let btn =
                "<center> <a href='" +
                url +
                "'target='_blank' class='btn btn-complete'> <i class='bi bi-box-arrow-up-right mr-1' ></i> Kunjungi Berita</a></center>";
              self.table.row
                .add([
                  self.dataBerita[index].title ? self.dataBerita[index] : "-",
                  self.dataBerita[index].account,
                  date,
                  btn,
                ])
                .node().id = index;
              self.table.columns.adjust().draw();
            }
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
  },
  created: function () {
    let self = this;
    self.table = $("#listStreamTable").DataTable();
  },
  mounted: function () {
    let self = this;
    self.table = $("#listStreamTable").DataTable();
    this.getData();
  },
};
</script>

<style scoped>
.form-control {
  -webkit-appearance: button;
}
select {
  cursor: pointer;
}
</style>